(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const init = () => {
      const nav = document.querySelector('[data-nav-island]');
      if (!nav || nav.dataset.ready) return;
      nav.dataset.ready = '1';
      const wrap = nav.querySelector('[data-nav-pills]');
      if (wrap) {
        const links = [...wrap.querySelectorAll('[data-nav-link]')];
        const pill = (a) => {
          links.forEach((l) => l.toggleAttribute('data-pill-on', l === a));
          if (!a) {
            wrap.removeAttribute('data-pill');
            return;
          }
          const w = wrap.getBoundingClientRect();
          const r = a.getBoundingClientRect();
          wrap.style.setProperty('--px', r.left - w.left + 'px');
          wrap.style.setProperty('--pw', r.width + 'px');
          wrap.setAttribute('data-pill', '');
        };
        links.forEach((a) => {
          a.addEventListener('mouseenter', () => pill(a));
          a.addEventListener('focus', () => pill(a));
        });
        wrap.addEventListener('mouseleave', () => pill(null));
        wrap.addEventListener('focusout', (e) => {
          if (!wrap.contains(e.relatedTarget)) pill(null);
        });
      }
      let last = scrollY;
      let ticking = false;
      addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const y = scrollY;
            if (y > last + 8 && y > 320) nav.setAttribute('data-hide', '');
            else if (y < last - 8 || y < 120) nav.removeAttribute('data-hide');
            last = y;
            ticking = false;
          });
        },
        { passive: true }
      );
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melie-loupe"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready !== undefined) return;
      root.dataset.ready = '';
      const spots = [...root.querySelectorAll('[data-spot]')];
      spots.forEach((spot) => {
        spot.addEventListener('click', () => {
          /* gewählte Spitze bleibt an Ort und Stelle, auch wenn die Beschreibung darüber anders hoch ist */
          const before = spot.getBoundingClientRect().top;
          spots.forEach((s) => {
            const on = s === spot;
            s.setAttribute('aria-pressed', String(on));
            const panel = root.querySelector('#' + s.dataset.spot);
            if (panel) panel.hidden = !on;
          });
          const diff = spot.getBoundingClientRect().top - before;
          if (Math.abs(diff) > 1) window.scrollBy({ top: diff, behavior: 'instant' });
        });
      });
    };
    const boot = () => document.querySelectorAll('[data-loupe]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-loupe]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["melie-tower"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready !== undefined) return;
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const grid = root.querySelector('[data-grid]');
      const cards = [...root.querySelectorAll('.m-tcard')];
      if (!tabs.length || !grid) return;
      root.dataset.ready = '';

      const select = (tab, focus, user) => {
        const tech = tab.dataset.tech;
        /* Reiter bleibt beim Umschalten an Ort und Stelle, auch wenn sich die Höhe darunter ändert */
        const before = user ? tab.getBoundingClientRect().top : 0;
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
        });
        grid.setAttribute('aria-labelledby', tab.id);
        cards.forEach((c) => {
          const show = tech === 'alle' || c.dataset.tech.split(' ').includes(tech);
          const was = !c.hidden;
          c.hidden = !show;
          if (show && (!was || user)) {
            c.style.animation = 'none';
            void c.offsetWidth;
            c.style.animation = '';
          }
        });
        if (focus) tab.focus({ preventScroll: true });
        if (user) {
          const diff = tab.getBoundingClientRect().top - before;
          if (Math.abs(diff) > 1) window.scrollBy({ top: diff, behavior: 'instant' });
        }
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab, false, true));
        tab.addEventListener('keydown', (e) => {
          const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!step) return;
          e.preventDefault();
          select(tabs[(i + step + tabs.length) % tabs.length], true, true);
        });
      });

      select(tabs.find((t) => t.dataset.tech === root.dataset.default) || tabs[0]);
    };

    const boot = () => document.querySelectorAll('[data-tower]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('[data-tower]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      root.querySelectorAll('[data-gallery]').forEach(function (g) {
        if (g.dataset.ready) return;
        g.dataset.ready = '1';
        var stage = g.querySelector('[data-stage]');
        var slides = Array.prototype.slice.call(g.querySelectorAll('[data-slide]'));
        var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
        if (!stage || !slides.length) return;
        var mark = function (i) {
          thumbs.forEach(function (t, k) {
            t.setAttribute('aria-pressed', String(k === i));
          });
        };
        thumbs.forEach(function (t, i) {
          t.addEventListener('click', function () {
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            stage.scrollTo({ left: slides[i].offsetLeft - stage.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
            mark(i);
          });
        });
        var raf = 0;
        stage.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var i = Math.round(stage.scrollLeft / Math.max(stage.clientWidth, 1));
            mark(Math.min(Math.max(i, 0), slides.length - 1));
          });
        });
        stage.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          stage.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * stage.clientWidth, behavior: 'smooth' });
        });
      });
    }
    function initModels() {
      if (!document.querySelector('.m-pdp model-viewer')) return;
      if (window.customElements && window.customElements.get('model-viewer')) return;
      if (!window.Shopify || !window.Shopify.loadFeatures) return;
      window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12', onLoad: function () {} }]);
    }
    function boot() {
      initGallery(document);
      initModels();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      initGallery(e.target);
      initModels();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
